import { editorPicks } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const main = editorPicks[0];
const list = editorPicks.slice(1);

export default function EditorPicks() {
  return (
    <section id="picks" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="EDITOR'S PICKS"
          title="编辑精选 · 本周必看"
          desc="不是算法推的，是我们一部一部看完后，想拉着你一起重看的那种片子。"
          actionLabel="全部精选"
          actionHref="#columns"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-7 group">
            <a href="#library" className="block">
              <div className="relative w-full h-56 sm:h-72 lg:h-80 rounded-lg overflow-hidden">
                <img
                  src={main.image}
                  alt={`${main.title} 青春电影专题封面`}
                  title={`${main.title} - 青苹果影院编辑精选`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-md">
                  {main.tag}
                </span>
              </div>
              <div className="pt-4">
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {main.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{main.excerpt}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span>{main.meta}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    {main.read}
                  </span>
                </div>
              </div>
            </a>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {list.map((item, idx) => (
              <a
                key={item.id}
                href="#library"
                className="group flex gap-4 bg-background-100 border border-background-200 rounded-lg p-4 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
              >
                <span className="shrink-0 w-9 h-9 rounded-md bg-background-50 border border-background-200 text-primary-700 font-bold flex items-center justify-center">
                  {idx + 2}
                </span>
                <div className="min-w-0">
                  <span className="text-[11px] font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                  <h3 className="mt-1.5 text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="mt-1.5 text-xs text-foreground-500">{item.meta}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}